export default [
  { id: 'paid', label: 'Paid', colour: '#4DB6AC' },
  { id: 'open', label: 'Failed', colour: '#FC5E66' },
  { id: 'requiresAction', label: 'Requires Action', colour: '#6651a7' },
  { id: 'void', label: 'Void', colour: '#4c4c4c' },
  { id: 'draft', label: 'Pending', colour: '#fdbf2a' }
];
